/**
 * Amazon Associates tracking tag (e.g. "splitline-20"). Empty: equipment links
 * still work, as plain Amazon searches with no commission and no disclosure.
 * When set, every page with an equipment link shows Amazon's required
 * disclosure, and the links are marked rel="sponsored".
 */
export const AMAZON_TAG = '';

export const AMAZON_DISCLOSURE = 'As an Amazon Associate, Splitline earns from qualifying purchases.';

/** An Amazon search link: robust to listings changing, and no prices (Amazon allows those only via its API). */
export function amazonSearchUrl(query: string): string {
  const params = new URLSearchParams({ k: query });
  if (AMAZON_TAG) params.set('tag', AMAZON_TAG);
  return `https://www.amazon.com/s?${params}`;
}
